import React from "react";
import BreadCrumb from "../../Components/BreadCrumb";
import CaseStatus from "./CaseStatus";
import DailyOrder from "./DailyOrder";

const DailyOrderPage = (benchId) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Daily Order" />
        <div className="about-bg inner-page-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <DailyOrder benchId={benchId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyOrderPage;
